import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M971.153351,416.337587 C1012.92433,667.183858 1228.43455,858.591238 1488.69314,858.591238 L1488.69314,858.591238 L1488.69314,1566.19708 L729.809921,1566.19708 L262.710555,1920 L262.710555,1566.19708 L1.64515022e-12,1566.19708 L2.28664911e-13,416.337587 Z M1689.50909,0 L1813.33333,125.069332 L1612.5349,327.886857 L1813.33333,530.704381 L1689.50909,655.773714 L1488.71066,452.956189 L1287.91222,655.773714 L1164.08798,530.704381 L1364.88642,327.886857 L1164.08798,125.069332 L1287.91222,0 L1488.71066,202.817524 L1689.50909,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommentsOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCommentsOffSolid, _Component);

  var _super = _createSuper(IconCommentsOffSolid);

  function IconCommentsOffSolid() {
    _classCallCheck(this, IconCommentsOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommentsOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCommentsOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommentsOffSolid.displayName = "IconCommentsOffSolid";
  return IconCommentsOffSolid;
}(Component);

IconCommentsOffSolid.glyphName = 'comments-off';
IconCommentsOffSolid.variant = 'Solid';
IconCommentsOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommentsOffSolid;
export { IconCommentsOffSolid };